import * as ApiModels from '@/typings/api-models';

export const columns = ['type', 'action', 'taken by', 'item', 'date'];

export const FILTERS: { value: ApiModels.ACTIVITY_TYPES | 'all'; title: string }[] = [
  {
    title: 'All',
    value: 'all',
  },
  {
    title: 'Message',
    value: ApiModels.ACTIVITY_TYPES.MESSAGE,
  },
  {
    title: 'Terms',
    value: ApiModels.ACTIVITY_TYPES.TERMS,
  },
  {
    title: 'Document request',
    value: ApiModels.ACTIVITY_TYPES.DOCUMENT_REQUEST,
  },
  {
    title: 'Status change',
    value: ApiModels.ACTIVITY_TYPES.STATUS_CHANGE,
  },
  {
    title: 'Payment',
    value: ApiModels.ACTIVITY_TYPES.PAYMENT,
  },
];
